import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SharedLayoutsService } from '../shared-layouts.service';

@Component({
    selector: 'app-two-col-banner-with-title-v2',
    templateUrl: './two-col-banner-with-title-v2.component.html',
    styleUrls: ['./two-col-banner-with-title-v2.component.scss'],
})
export class TwoColBannerWithTitleV2Component implements OnInit {
    @Input() item: any;
    @Input() showShimmer = true;
    @Output() emitLink: EventEmitter<string> = new EventEmitter();

    constructor(protected sharedLayoutsService: SharedLayoutsService) {}

    ngOnInit(): void {}

    processLink(link: string) {
        this.emitLink.emit(link);
    }
}
